import React, { ReactNode, ReactNodeArray, FC, PropsWithChildren } from 'react'
// libs
import cx from 'classnames'
// components
import Message from 'components/Form/Message'
// types
import { Classes } from 'jss'
import { WrappedFieldMetaProps } from 'redux-form'
// styles
import injectSheet from 'react-jss'
import { fieldsClasses } from './sheet'

interface PropsTitle {
  id?: string
  title?: string
  classes: Classes
  required?: boolean
}

const TitleFieldStyleless = ({ id, title, classes, required }: PropsTitle) => {
  return (
    <div className={classes.wrapper}>
      <label htmlFor={id} className={'text-14 text-regular'}>
        {title} {required && <span className={'text-14 text-regular text-danger'}>{' *'}</span>}
      </label>
    </div>
  )
}

export const TitleField = injectSheet(fieldsClasses)(TitleFieldStyleless)

interface PropsError {
  error?: string
}
const ErrorField = ({ error }: PropsError) => {
  return <div className={'text-12 text-regular text-danger'}>{error}</div>
}

export const FieldWrapperStyleless = ({
  children,
  title,
  classes,
  error,
  ...rest
}: PropsError & PropsTitle & PropsWithChildren<{}>) => {
  return (
    <div>
      {title && <TitleField {...rest} title={title} />}
      <div>{children}</div>
      {title && <ErrorField error={error} />}
    </div>
  )
}

export const FieldWrapper = injectSheet(fieldsClasses)(FieldWrapperStyleless)
